import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { PayloadAction } from "@reduxjs/toolkit";
import { ISkillmemory } from "../../../Pages/Skillstrainer/ISkill";
import {
  failureaddMemoryGameSkill,
  successaddMemoryGameSkill,
} from "./AddMemoryGameSkillSlice";

// add
const AddMemoryGameSkillApi = (action: PayloadAction<ISkillmemory>) => {
  return api.post("/api/settings/memory-trainer", action.payload);
};

export function* AddMemoryGameSkillCall(action: PayloadAction<ISkillmemory>) {
  try {
    const response: AxiosResponse = yield call(AddMemoryGameSkillApi, action);
    yield put(successaddMemoryGameSkill(response.data));
  } catch (error) {
    yield put(failureaddMemoryGameSkill(error));
  }
}
